import React, { useState, useCallback, useMemo, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import EventFormStep3 from "./EventFormStep3";

// --- GOOGLE ANALYTICS HELPER ---
const sendGoogleAnalyticsEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'Event_Calculator',
      ...parameters
    });
  } else {
    console.log('GA Event:', eventName, parameters); // For testing
  }
};

// --- ДАННЫЕ ОБ УСЛУГАХ --- 
const familyServicesData = [
  { id: "fancy_picnic", name: "Фэнси-пикник с сервировкой", priceMin: 1900, priceMax: 2500, perPerson: false, description: "Низкий стол, сервированный настоящей посудой, бокалами, живыми цветами и свечами. Посадка на подушках. В комплекте: высокий стол для кейтеринга, одноразовая посуда, штопор, влажные салфетки, мусорные мешки, зажигалка, мини-колонка. Монтаж и демонтаж включены.", gallery: [] },
  { id: "poufs_zone", name: "Зона с пуфами", priceMin: 4400, priceMax: 6500, perPerson: false, description: "Большие уличные пуфы и индивидуальные низкие столики, украшенные цветами и свечами. Расчёт по формуле: гости минус 5, исходя из нашего опыта (можно добавить места по желанию).", gallery: [] },
  { id: "mat_pillows", name: "Циновка и подушки", priceMin: 800, priceMax: 1500, perPerson: false, description: "Идеальное дополнение к зоне отдыха — например, на детском празднике. Большая циновка 4×5 м или 5×5 м + подушки для сидения.", gallery: [] },
  { id: "catering", name: "Кейтеринг", priceMin: 140, priceMax: 260, perPerson: true, description: "Меню под запрос: Кошер / Кошер-стайл / Веган / Микс. Доступна шефская подача и выезд на дом. Стоимость индивидуальна.", gallery: [] },
  { id: "kids_menu", name: "Меню для детей", priceMin: 50, priceMax: 80, perPerson: true, description: "Простые и любимые блюда, подходящие для тоддлеров и взрослых. Составляется с учетом возрастов гостей.", gallery: [] },
  { id: "bbq_chef", name: "Шашлычник на выезд", priceMin: 2000, priceMax: 4000, perPerson: false, description: "Мясо (кебабы, курица), картофель, питы. Приезд с собственным оборудованием. Цена на 15–30 гостей.", gallery: [] },
  { id: "drinks", name: "Напитки", priceMin: 150, priceMax: 350, perPerson: false, description: "Всегда включаем: воду, соки, газировку. Дополнительные пожелания обсуждаются индивидуально.", gallery: [] },
  { id: "mobile_bar", name: "Выездной бар", priceMin: 2300, priceMax: 4000, perPerson: false, description: "Бармен, стойка, ингредиенты, коктейльная карта и эффектная подача с украшениями и логотипом. Идеально для праздников на открытом воздухе. Цена на 15–30 гостей.", gallery: [] },
  { id: "waiter", name: "Официант", priceMin: 350, priceMax: 500, perPerson: false, description: "1 официант работает от 5 часов. Создаёт чистую, аккуратную и комфортную атмосферу — это всегда +100 к впечатлению от праздника.", gallery: [] },
  { id: "balloons", name: "Оформление шарами", priceMin: 800, priceMax: 2500, perPerson: false, description: "Бюджетный вариант: мольберт с шарами и табличкой. По запросу — креативные и тематические оформления.", gallery: [] },
  { id: "animator", name: "Аниматор", priceMin: 2000, priceMax: 2600, perPerson: false, description: "Программа и костюмы по запросу. Продолжительность — от 1 часа.", gallery: [] },
  { id: "photo", name: "Фотосъёмка", priceMin: 700, priceMax: 1400, perPerson: false, description: "Репортажная съёмка на улице или в помещении. Опционально: видеоролик, печать фотокниг. Уточните при заказе.", gallery: [] },
  { id: "video", name: "Видеоролик", priceMin: 1000, priceMax: 1500, perPerson: false, description: "Профессиональная съёмка + монтаж короткого ролика (1,5 минуты). Отлично для воспоминаний и соцсетей.", gallery: [] },
  { id: "live_music", name: "Живая музыка", priceMin: 3000, priceMax: 6000, perPerson: false, description: "Музыканты по вашему вкусу, работают 2–4 часа. Идеально для атмосферы праздника.", gallery: [] },
  { id: "dj", name: "Диджей", priceMin: 3500, priceMax: 4500, perPerson: false, description: "Подбор и составление плейлиста по вашим предпочтениям. Время работы — 2–4 часа.", gallery: [] },
  { id: "venue_search", name: "Поиск площадки", priceMin: 1000, priceMax: 1500, perPerson: false, description: "Поиск локации под ваш праздник: район, тип помещения (крыша, опен-спейс, зал), количество гостей. Всё подбирается по вашим параметрам.", gallery: [] }
];

const b2bServicesData = [
  { id: "venue_rent", name: "Аренда помещения", priceMin: 6000, priceMax: 12000, perPerson: false, description: "Примерная стоимость аренды в Тель-Авиве для 50–100 гостей. Итоговая цена зависит от ваших пожеланий и доступности локаций.", gallery: [] },
  { id: "administration", name: "Администрирование и подготовка", priceMin: 3000, priceMax: 5000, perPerson: false, description: "Разработка сценария, координация, контроль исполнения. Полное сопровождение мероприятия.", gallery: [] },
  { id: "venue_search", name: "Поиск помещения", priceMin: 1000, priceMax: 1500, perPerson: false, description: "Подбор помещения по параметрам клиента", gallery: [] },
  { id: "catering", name: "Кейтеринг", priceMin: 5000, priceMax: 8500, perPerson: false, description: "Фингер-фуд для деловых мероприятий из расчета 50-100 гостей. Под запрос: Кошер с теудой / Кошер-стайл без теуды / Веган / Микс-меню", gallery: [] },
  { id: "bar_service", name: "Барное обслуживание", priceMin: 3000, priceMax: 7800, perPerson: false, description: "Профессиональные бармены, разработка коктейльной карты, закупка ингредиентов, подача с фирменным логотипом. По запросу: выездная барная стойка, оборудование, аренда стеклянной посуды.", gallery: [] },
  { id: "waiters", name: "Официанты", priceMin: 400, priceMax: 700, perPerson: false, description: "1 официант на каждые 20 гостей (для формата фуршет). Обеспечивают чистоту, комфорт и внимание к деталям. Время работы от 5 часов.", gallery: [] },
  { id: "registration", name: "Регистрация", priceMin: 500, priceMax: 1000, perPerson: false, description: "Сбор и обработка данных участников. Подходит для последующей маркетинговой работы.", gallery: [] },
  { id: "photo_zone", name: "Фотозона", priceMin: 2400, priceMax: 6000, perPerson: false, description: "Фирменный баннер с логотипом или креативный прессвол с шарами, цветами и элементами декора.", gallery: [] },
  { id: "rollup", name: "Роллап", priceMin: 400, priceMax: 2400, perPerson: false, description: "Стабильные брендированные роллапы для навигации и оформления пространства. Расчет в калькуляторе на 1-6 шт.", gallery: [] },
  { id: "badges", name: "Бейджи", priceMin: 1000, priceMax: 3000, perPerson: false, description: "Создание макетов или печать по готовым шаблонам. Удобная идентификация и имиджевый элемент. Расчет в калькуляторе на 100-300 шт.", gallery: [] },
  { id: "surface_branding", name: "Брендирование поверхностей", priceMin: 800, priceMax: 3000, perPerson: false, description: "Яркий визуальный акцент и запоминающийся стиль. Макеты, печать и монтаж на месте.", gallery: [] },
  { id: "branded_products", name: "Производство брендированной продукции", priceMin: 1000, priceMax: 3000, perPerson: false, description: "Ручки, блокноты, пакеты, визитки, сумки и другие брендированные материалы под заказ.", gallery: [] },
  { id: "equipment_rent", name: "Аренда оборудования (экран, проектор, звук, свет)", priceMin: 1000, priceMax: 3000, perPerson: false, description: "Аренда оборудования, необходимого для бизнес-мероприятий (экраны, проекторы, микрофоны и т.д.).", gallery: [] },
  { id: "photo", name: "Фотосъемка", priceMin: 1200, priceMax: 2000, perPerson: false, description: "Профессиональный фоторепортаж с обработкой. Готовность — в течение 1 рабочей недели.", gallery: [] },
  { id: "video", name: "Видеосъемка", priceMin: 1500, priceMax: 2500, perPerson: false, description: "Динамичный ролик с ключевыми моментами события. Готов для публикации в соцсетях и рассылки.", gallery: [] },
  { id: "dj", name: "Диджей", priceMin: 3000, priceMax: 4500, perPerson: false, description: "Подборка плейлистов, соответствующих атмосфере деловой встречи. Создает настроение и комфорт для общения.", gallery: [] }
];

const pageVariants = { 
  initial: { opacity: 0, x: 40 }, 
  animate: { opacity: 1, x: 0 }, 
  exit: { opacity: 0, x: -40 } 
};

// Generate session ID for analytics
if (typeof window !== 'undefined' && !window.sessionStorage.getItem('calc_session_id')) {
  window.sessionStorage.setItem('calc_session_id', Date.now().toString());
}

const initialFormState = { 
  eventType: "", 
  category: "", 
  guests: 0, 
  children: 0, 
  separateMenu: false, 
  services: [], 
  comment: "", 
  name: "", 
  phone: "", 
  email: "" 
};

// Custom Alert Component
const CustomAlert = ({ message, type = "error", onClose }) => (
  <motion.div
    className={`custom-alert alert-${type}`}
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3 }}
  >
    <span>{message}</span>
    <button onClick={onClose} className="alert-close">×</button>
  </motion.div>
);

const ServiceInfoModalComponent = React.memo(
  ({ service, onClose, onOpenGallery }) => (
    <div className="modal-bg" onClick={onClose}>
      <motion.div
        className="modal"
        onClick={e => e.stopPropagation()}
        initial={{ opacity: 0, y: 40, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 40, scale: 0.98 }}
        transition={{ duration: 0.23 }}
      >
        <h3>{service.name}</h3>
        <p>{service.description}</p>
        <div className="modal-gallery">
          {service.gallery.map((url, i) => (
            <img
              key={i}
              src={url}
              alt={`${service.name} gallery ${i + 1}`}
              onClick={() => onOpenGallery(url)}
              style={{ cursor: "pointer" }}
            />
          ))}
        </div>
        <button className="modal-close" onClick={onClose}>
          Закрыть
        </button>
      </motion.div>
    </div>
  )
);

const ImageGalleryModalComponent = React.memo(
  ({ image, onClose }) => (
    <div className="modal-bg" onClick={onClose}>
      <motion.div
        className="gallery-modal"
        onClick={e => e.stopPropagation()}
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.97 }}
        transition={{ duration: 0.2 }}
      >
        <img
          src={image}
          alt="Фото услуги (увеличено)"
          className="gallery-img"
        />
        <button className="modal-close gallery-close" onClick={onClose}>
          Закрыть
        </button>
      </motion.div>
    </div>
  )
);

export default function App() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState(initialFormState);
  const [showThankYouPage, setShowThankYouPage] = useState(false);
  const [activeModalService, setActiveModalService] = useState(null);
  const [activeGalleryImage, setActiveGalleryImage] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const [alertMessage, setAlertMessage] = useState(null);
  const [priceViewed, setPriceViewed] = useState(false);

  // Auto-resize iframe functionality
  useEffect(() => {
    const updateHeight = () => {
      const height = document.documentElement.scrollHeight;
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ 
          type: 'resize', 
          height: height,
          step: step,
          hasModal: !!(activeModalService || activeGalleryImage)
        }, '*');
      }
    };

    // Update height when step changes or important content changes
    const timer = setTimeout(updateHeight, 300); // Delay for animations

    return () => clearTimeout(timer);
  }, [step, showThankYouPage]);

  // --- useMemo/Callback ---
  const currentServiceList = useMemo(
    () => (form.eventType === "b2b" ? b2bServicesData : familyServicesData),
    [form.eventType]
  );
  
  const calculatedPrices = useMemo(() => {
    let minTotal = 0, maxTotal = 0;
    const servicesToCalc = form.eventType === "b2b" ? b2bServicesData : familyServicesData;
    form.services.forEach((id) => {
      const s = servicesToCalc.find((x) => x.id === id);
      if (s) {
        const guestsMultiplier = s.perPerson ? Number(form.guests) || 1 : 1;
        minTotal += s.priceMin * guestsMultiplier;
        maxTotal += s.priceMax * guestsMultiplier;
      }
    });
    return { minTotal, maxTotal };
  }, [form.services, form.guests, form.eventType]);

  // Track when user reaches step 3 (price calculation)
  useEffect(() => {
    if (step === 3 && !priceViewed && calculatedPrices.minTotal > 0) {
      setPriceViewed(true);
      
      // Send analytics event when user sees the final price
      sendGoogleAnalyticsEvent('price_calculated', {
        event_type: form.eventType,
        category: form.category || 'N/A',
        guests_count: form.guests,
        children_count: form.children || 0,
        services_selected: form.services.join(','),
        services_count: form.services.length,
        price_min: calculatedPrices.minTotal,
        price_max: calculatedPrices.maxTotal,
        session_id: window.sessionStorage?.getItem('calc_session_id')
      });
    }
  }, [step, priceViewed, calculatedPrices, form]);

  const showAlert = useCallback((message, type = "error") => {
    setAlertMessage({ message, type });
    setTimeout(() => setAlertMessage(null), 4000);
  }, []);

  const toggleServiceSelection = useCallback(
    (id) => {
      setForm((prev) => ({
        ...prev,
        services: prev.services.includes(id)
          ? prev.services.filter((s) => s !== id)
          : [...prev.services, id],
      }));
    },
    []
  );

  const proceedToNextStep = useCallback(() => {
    // Enhanced validation with custom alerts
    if (!form.eventType) {
      showAlert("Выберите тип события.");
      return;
    }
    
    if (!form.category) {
      showAlert(`Выберите категорию ${form.eventType === "family" ? "семейного события" : "B2B события"}.`);
      return;
    }
    
    if (step === 2) {
      if (!form.guests || form.guests <= 0) {
        showAlert("Укажите количество гостей (минимум 1).");
        return;
      }
      
      if (form.eventType === "family" && (form.children === "" || form.children < 0)) {
        showAlert("Количество детей не может быть отрицательным.");
        return;
      }
      
      if (!form.services.length) {
        showAlert("Выберите хотя бы одну услугу.");
        return;
      }

      // Send analytics when user completes service selection
      sendGoogleAnalyticsEvent('services_selected', {
        event_type: form.eventType,
        category: form.category || 'N/A',
        guests_count: form.guests,
        services_selected: form.services.join(','),
        services_count: form.services.length,
        session_id: window.sessionStorage?.getItem('calc_session_id')
      });
    }
    
    setStep((s) => Number(s) + 1);
  }, [step, form, showAlert]);

  const goPrevStep = useCallback(() => setStep((s) => Number(s) - 1), []);

  // --- Главная функция сброса ---
  const resetForm = useCallback(() => {
    setFormKey((k) => k + 1);
    setShowThankYouPage(false);
    setStep(1);
    setForm(initialFormState);
    setPriceViewed(false);
    
    // Send analytics for form reset
    sendGoogleAnalyticsEvent('form_reset', {
      session_id: window.sessionStorage?.getItem('calc_session_id')
    });
  }, []);

  // --- Модалки ---
  const openServiceModal = useCallback((service) => setActiveModalService(service), []);
  const closeServiceModal = useCallback(() => setActiveModalService(null), []);
  const openGalleryModalFromService = useCallback((imageUrl) => {
    setActiveModalService(null);
    setActiveGalleryImage(imageUrl);
  }, []);
  const closeGalleryModal = useCallback(() => setActiveGalleryImage(null), []);

  const handleFormChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => {
      const newForm = {
        ...prev,
        [name]: type === "checkbox" ? checked : type === "number" ? parseInt(value, 10) || 0 : value,
      };
      
      if (name === "eventType") {
        newForm.category = "";
        newForm.services = [];
        // Send analytics for event type selection
        sendGoogleAnalyticsEvent('event_type_selected', {
          event_type: value,
          session_id: window.sessionStorage?.getItem('calc_session_id')
        });
      }
      
      if (name === "category") {
        newForm.services = [];
        // Send analytics for category selection
        sendGoogleAnalyticsEvent('category_selected', {
          event_type: prev.eventType,
          category: value,
          session_id: window.sessionStorage?.getItem('calc_session_id')
        });
      }
      
      return newForm;
    });
  }, []);

  return (
    <div className="container">
      <AnimatePresence>
        {alertMessage && (
          <CustomAlert
            message={alertMessage.message}
            type={alertMessage.type}
            onClose={() => setAlertMessage(null)}
          />
        )}
      </AnimatePresence>
      
      <AnimatePresence mode="wait">
        {showThankYouPage ? (
          <motion.div
            key={`thankyou_page-${formKey}`}
            {...pageVariants}
            transition={{ duration: 0.4 }}
          >
            <h2>Спасибо за ваш запрос!</h2>
            <p>
              Мы получили информацию о вашем мероприятии. Наш менеджер свяжется
              с вами в ближайшее время.
            </p>
            <button onClick={resetForm}>Начать новый расчет</button>
            <div className="contact-block">
              <div className="contact-label">Или свяжитесь с нами:</div>
              <div className="contact-phone">
                Телефон: <a href="tel:+972535934876">+972535934876</a>
              </div>
              <div className="contact-actions">
                <a
                  className="contact-btn whatsapp"
                  href="https://wa.me/972535934876"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp
                </a>
                <a
                  className="contact-btn instagram"
                  href="https://www.instagram.com/minaker.events/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </div>
            </div>
          </motion.div>
        ) : (
          <motion.div
            key={`step_page-${step}-${formKey}`}
            {...pageVariants}
            transition={{ duration: 0.4 }}
          >
            {step === 1 && (
              <>
                <label htmlFor="eventType">
                  <h1>Калькулятор мероприятий</h1>Тип события:
                </label>
                <select
                  id="eventType"
                  name="eventType"
                  value={form.eventType}
                  onChange={handleFormChange}
                >
                  <option value="">Выберите</option>
                  <option value="family">Семейное</option>
                  <option value="b2b">B2B (корпоратив/деловое)</option>
                </select>
                {form.eventType === "family" && (
                  <>
                    <label htmlFor="category">Категория:</label>
                    <select
                      id="category"
                      name="category"
                      value={form.category}
                      onChange={handleFormChange}
                    >
                      <option value="">Выберите</option>
                      <option value="picnic">Пикник</option>
                      <option value="turnkey_party">Праздник под ключ</option>
                      <option value="kids_birthday">Детский день рождения</option>
                      <option value="wedding">Свадьба</option>
                      <option value="proposal">Предложение</option>
                      <option value="other">Другое</option>
                    </select>
                  </>
                )}
                {form.eventType === "b2b" && (
                  <>
                    <label htmlFor="category">Категория:</label>
                    <select
                      id="category"
                      name="category"
                      value={form.category}
                      onChange={handleFormChange}
                    >
                      <option value="">Выберите</option>
                      <option value="networking">Нетворкинг</option>
                      <option value="business_breakfast">Бизнес-завтрак</option>
                      <option value="product_presentation">Презентация продукта</option>
                      <option value="corporate">Корпоратив</option>
                      <option value="other">Другое</option>
                    </select>
                  </>
                )}
                <div className="buttons single-button">
                  <button onClick={proceedToNextStep}>Далее</button>
                </div>
              </>
            )}
            
            {step === 2 && (
              <>
                <h2>Информация о гостях</h2>
                <div className="guest-info">
                  <div>
                    <label htmlFor="guests">Гостей:</label>
                    <input
                      id="guests"
                      name="guests"
                      type="number"
                      min="1"
                      value={form.guests || ""}
                      onChange={handleFormChange}
                    />
                  </div>
                  {form.eventType === "family" && (
                    <div>
                      <label htmlFor="children">Детей (0, если нет):</label>
                      <input
                        id="children"
                        name="children"
                        type="number"
                        min="0"
                        value={form.children || ""}
                        onChange={handleFormChange}
                      />
                    </div>
                  )}
                </div>
                {form.eventType === "family" && form.children > 0 && (
                  <div className="separate-menu-row">
                    <input
                      type="checkbox"
                      id="separateMenu"
                      name="separateMenu"
                      checked={form.separateMenu}
                      onChange={handleFormChange}
                    />
                    <label htmlFor="separateMenu">
                      Отдельное меню для детей
                    </label>
                  </div>
                )}
                <h2>Услуги</h2>
                <div className="services">
                  {currentServiceList.map((s) => (
                    <div key={s.id} className="service-item">
                      <input
                        type="checkbox"
                        id={s.id}
                        checked={form.services.includes(s.id)}
                        onChange={() => toggleServiceSelection(s.id)}
                      />
                      <label htmlFor={s.id} className="service-name-label">
                        {s.name}
                      </label>
                      <span className="service-price">
                        {s.perPerson
                          ? `${s.priceMin}–${s.priceMax} ₪ / чел.`
                          : `${s.priceMin}–${s.priceMax} ₪`}
                      </span>
                      <button
                        type="button"
                        className="service-more"
                        onClick={() => openServiceModal(s)}
                        title="Подробнее об услуге"
                      >
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="9" stroke="#9D80BA" strokeWidth="2" fill="#fff" />
                          <text x="10" y="15" textAnchor="middle" fill="#9D80BA" fontSize="14" fontWeight="bold">i</text>
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
                <div className="comment">
                  <label htmlFor="comment">Дополнительные пожелания:</label>
                  <textarea
                    id="comment"
                    name="comment"
                    value={form.comment}
                    onChange={handleFormChange}
                    placeholder="Укажите ваши особые пожелания..."
                  />
                </div>
                <div className="buttons">
                  <button onClick={goPrevStep}>Назад</button>
                  <button onClick={proceedToNextStep}>Далее</button>
                </div>
              </>
            )}
            
            {step === 3 && (
              <EventFormStep3
                key={`event-form-step3-${formKey}`}
                form={form}
                calculatedPrices={calculatedPrices}
                goPrevStep={goPrevStep}
                resetForm={resetForm}
                showThankYouPage={showThankYouPage}
                setShowThankYouPage={setShowThankYouPage}
                sendAnalyticsEvent={sendGoogleAnalyticsEvent}
                handleFormChange={handleFormChange}
                showAlert={showAlert}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
      
      <AnimatePresence>
        {activeModalService && (
          <ServiceInfoModalComponent
            key={activeModalService.id}
            service={activeModalService}
            onClose={closeServiceModal}
            onOpenGallery={openGalleryModalFromService}
          />
        )}
        {activeGalleryImage && (
          <ImageGalleryModalComponent
            key={activeGalleryImage}
            image={activeGalleryImage}
            onClose={closeGalleryModal}
          />
        )}
      </AnimatePresence>
    </div>
  );
}